import {useState} from "react"

export const LIGHTBOX__GALLERY = 'lightbox_gallery'

export const useLightbox = () => {
    const [state, setState] = useState([])

    const has = (type) => {
        return state.includes(type)
    }

    const open = (type) => {
        if(!has(type)) setState(prevState => [...prevState, type])
    }

    const close = () => {
        setState(prevState => {
            const newState = [...prevState]
            newState.pop()
            return newState
        })
    }

    const getZIndex = (type) => {
        return state.indexOf(type) + 3
    }

    const isTop = (type) => {
        return state[state.length - 1] === type
    }

    const hasGallery = () => has(LIGHTBOX__GALLERY)
    const openGallery = () => open(LIGHTBOX__GALLERY)

    return {
        close, getZIndex, isTop,
        hasGallery, openGallery
    }
}
